import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ne',
    fullName: 'Nepali',
    nativeName: 'नेपाली',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "अचम्मको कुरा आउँदैछ",
    landing_subtitle: "ArgVoid एउटा एप र खेल विकास स्टुडियो हो। सम्पर्कमा रहनुहोस्, नयाँ चीजहरू चाँडै आउँदैछन्!",
    select_language: "भाषा चयन गर्नुहोस्",
    search_placeholder: "भाषाहरू खोज्नुहोस्...",
    terms_title: "सेवाका सर्तहरू",
    policy_title: "गोपनीयता नीति",
    cookies_title: "कुकी नीति",
    terms_content: `
        <strong>1। सर्तहरू</strong><br> को स्वीकृति
        ArgVoid पहुँच गरेर, यी सेवा सर्तहरू स्वीकार गरिन्छ। यदि यी सर्तहरूमा सहमत भएन भने, सेवा प्रयोग गर्नु हुँदैन।<br><br>

        <strong>2। प्लेटफर्म प्रयोग</strong><br>
        ArgVoid र यसका अनुप्रयोगहरू सूचना र रचनात्मक उद्देश्यका लागि "जस्तै छ" प्रदान गरिन्छ। सेवा वैध उद्देश्यका लागि मात्र प्रयोग गरिनुपर्छ।<br><br>

        <strong>3। निषेधित आचरण</strong><br>
        साइट कमजोरीहरूको शोषण, स्प्यामिङ, वा पूर्वाधारमा अनधिकृत पहुँच प्रयास गर्न कडा रूपमा निषेधित छ।<br><br>

        <strong>4। अस्वीकरण</strong><br>
        प्लेटफर्म र सेवाहरू सूचना बिना कुनै पनि समयमा परिमार्जन गर्न सकिन्छ। सेवाको अपटाइम वा उपलब्धताको सन्दर्भमा कुनै वारेन्टी प्रदान गरिएको छैन।
    `,
    policy_content: `
        <strong>1। जानकारी सङ्कलन</strong><br>
        प्लेटफर्मलाई यस समयमा प्रयोगकर्ता प्रमाणीकरण वा खाता सिर्जना आवश्यक पर्दैन। कुनै पनि व्यक्तिगत पहिचान जानकारी (जस्तै नाम वा इमेल ठेगानाहरू) सक्रिय रूपमा आगन्तुकहरूबाट सङ्कलन गरिएको छैन।<br><br>

        <strong>2। प्रयोग डेटा</strong><br>
        साइट ट्राफिक बुझ्न र अनुप्रयोगहरू सुधार गर्न आधारभूत, अज्ञात विश्लेषणहरू सङ्कलन गर्न सकिन्छ। यो डाटा व्यक्तिगत प्रयोगकर्ता पहिचानसँग लिङ्क गरिएको छैन।<br><br>

        <strong>3। तेस्रो-पक्ष सेवाहरू</strong><br>
        तेस्रो-पक्ष प्रदायकहरू होस्टिङ र विश्लेषण सेवाहरूको लागि प्रयोग गर्न सकिन्छ। यी सम्बन्धित प्रदायकहरूको गोपनीयता अभ्यासहरूले तिनीहरूको पूर्वाधारमा प्रशोधन गरिएको अज्ञात डेटालाई नियन्त्रण गर्दछ।<br><br>

        <strong>4। डाटा सुरक्षा</strong><br>
        प्लेटफर्मको सुरक्षा गर्न उचित सुरक्षा उपायहरू लागू गरिन्छ। यद्यपि, इन्टरनेटमा प्रसारणको कुनै पनि विधि पूर्ण रूपमा सुरक्षित छैन।<br><br>
    `,
    cookies_content: `
        <strong>1। कुकीहरू र स्थानीय भण्डारण के हो? </strong><br>
        कुकीहरू र ब्राउजर स्थानीय भण्डारण भ्रमणहरूमा कन्फिगरेसन प्राथमिकताहरू सम्झन उपकरणमा भण्डारण गरिएका साना डेटा फाइलहरू हुन्।<br><br>

        <strong>2। उपयोग Purpose</strong><br>
        ब्राउजर LocalStorage कन्फिगरेसन सेटिङहरू बचत गर्न कडा रूपमा प्रयोग गरिन्छ, जस्तै: <br>
        - भाषा प्राथमिकताहरू<br>
        - प्रयोगकर्ता इन्टरफेस कन्फिगरेसन (जस्तै, लेआउट वा विषय सेटिङहरू) <br>
        - अस्थायी आवेदन cache<br><br>

        <strong>3। कुनै Tracking</strong><br> छैन
        कुकीहरू र स्थानीय भण्डारण विज्ञापन वा तेस्रो-पक्ष ट्र्याकिङ उद्देश्यका लागि प्रयोग गरिँदैन। सबै भण्डारण गरिएका डाटाहरू प्लेटफर्मको मुख्य कार्यक्षमताका लागि कडा रूपमा हो।<br><br>

        <strong>4। Control</strong><br>
        ब्राउजर डेटा ब्राउजर सेटिङहरू मार्फत कुनै पनि समयमा खाली गर्न सकिन्छ, जसले कुनै पनि स्थानीय कन्फिगरेसनहरू रिसेट गर्नेछ।
    `,
    cookie_consent_text: "तपाइँको सत्र सक्रिय राख्न, तपाइँको भाषा प्राथमिकता बचत, र अन्य अनुकूलन कन्फिगरेसनहरू जस्ता वेबसाइट कार्यहरू सही रूपमा सुनिश्चित गर्न हामी आधारभूत कुकीहरू प्रयोग गर्दछौं।",
    read_policy: "कुकी नीति पढ्नुहोस्",
    support_title: "सहायतालाई सम्पर्क गर्नुहोस्",
    support_subject_label: "विषय",
    support_message_label: "सन्देश",
    support_submit_button: "सन्देश पठाउनुहोस्",
    support_hint: "नोट: यसले सन्देश पठाउनको लागि तपाईंको पूर्वनिर्धारित इमेल अनुप्रयोग खोल्नेछ।",
    support_success_msg: "तपाईको इमेल एप खोल्दै...",
    support_error_msg: "सन्देश पठाउन असफल भयो। कृपया पछि पुन: प्रयास गर्नुहोस्।",
    explorer_title: "अन्वेषक",
    history_title: "इतिहास",
    animation_title: "एनिमेसन",
    config_title: "कन्फिगरेसन",
    tool_mouse: "चयन गर्नुहोस् (Ctrl+M)",
    tool_brush: "ब्रश (Ctrl+B)",
    tool_brush_mode: "टगल मोड (ठोस/स्पष्ट)",
    tool_eraser: "इरेजर (Ctrl+E)",
    tool_brush_size: "ब्रश आकार समायोजन गर्नुहोस्",
    tool_bucket: "भर्नुहोस् (Ctrl+F)",
    tool_eyedropper: "आँखा ड्रपर",
    tool_grid: "ग्रिड (Ctrl+Shift+B)",
    tool_rotate: "घुमाउनुहोस् (Ctrl+Shift+R)",
    tool_flip_h: "फ्लिप H (Ctrl+Shift+H)",
    tool_flip_v: "फ्लिप V (Ctrl+Shift+V)",
    tool_transpose: "ट्रान्सपोज (Ctrl+Shift+T)",
    label_width: "चौडाइ",
    label_height: "उचाइ",
    label_frames: "फ्रेमहरूको संख्या",
    label_animation: "एनिमेसन शैली",
    label_background_color: "पृष्ठभूमि रङ",
    label_interval: "अन्तराल",
    tool_anim_config: "एनिमेसन कन्फिगरेसन",
    label_new_width: "नयाँ चौडाइ",
    label_new_height: "नयाँ उचाइ",
    label_apply: "आवेदन दिनुहोस्",
    label_colors: "रंगहरू",
    label_size: "साइज",
    label_tolerance: "सहिष्णुता",
    val_horizontal: "तेर्सो",
    val_vertical: "ठाडो",
    val_sequence: "अनुक्रम",
    val_bounce: "उछाल",
    val_random: "अनियमित",
    val_solid: "ठोस",
    val_clear: "खाली गर्नुहोस्",
    action_add_sheet: "नयाँ पाना",
    action_import: "आयात गर्नुहोस्",
    action_export: "निर्यात गर्नुहोस्",
    action_sort_projects: "क्रमबद्ध गर्नुहोस्",
    sort_date_old: "सबैभन्दा पुरानो पहिलो",
    sort_date_new: "सबैभन्दा नयाँ पहिलो",
    sort_name_az: "नाम (A-Z)",
    sort_name_za: "नाम (Z-A)",
    action_new_sprite: "नयाँ स्प्राइट",
    action_new_project: "नयाँ परियोजना",
    modal_save_all_title: "सबै परिवर्तनहरू बचत गर्नुहोस्",
    modal_save_all_desc: "बचत गर्न सम्पत्तिहरू चयन गर्नुहोस्:",
    modal_save_selected: "चयन गरिएको बचत गर्नुहोस्",
    action_saved: "सुरक्षित गरियो",
    modal_create_sprite_title: "नयाँ स्प्राइट सिर्जना गर्नुहोस्",
    modal_create_project_title: "नयाँ परियोजना सिर्जना गर्नुहोस्",
    modal_add_sheet_title: "नयाँ पाना थप्नुहोस्",
    modal_rename_sheet_title: "पाना पुन: नामाकरण गर्नुहोस्",
    modal_rename_sprite_title: "स्प्राइटको नाम परिवर्तन गर्नुहोस्",
    modal_delete_sprite_title: "स्प्राइट मेटाउनुहोस्",
    modal_delete_project_title: "परियोजना मेटाउनुहोस्",
    modal_delete_sheet_title: "पाना मेटाउनुहोस्",
    placeholder_sprite_name: "नाम",
    placeholder_project_name: "नाम",
    placeholder_sheet_name: "नाम",
    placeholder_new_name: "नयाँ नाम",
    action_create: "सिर्जना गर्नुहोस्",
    action_add: "थप्नुहोस्",
    action_rename: "पुन: नामाकरण गर्नुहोस्",
    action_duplicate: "नक्कल",
    action_delete: "मेट्नुहोस्",
    action_cancel: "रद्द गर्नुहोस्",
    confirm_delete_sprite: "के तपाइँ यो स्प्राइट मेटाउन निश्चित हुनुहुन्छ?",
    confirm_delete_project: "के तपाइँ यो परियोजना मेटाउन निश्चित हुनुहुन्छ? सबै स्प्राइटहरू हटाइनेछ।",
    confirm_delete_sheet: "के तपाइँ यो पाना मेटाउन निश्चित हुनुहुन्छ?",
    err_select_sprite: "कृपया पहिले स्प्राइट चयन गर्नुहोस्।",
    err_select_project: "कृपया पहिले एउटा परियोजना चयन गर्नुहोस्।",
    err_name_empty: "नाम खाली हुन सक्दैन।",
    err_sprite_exists: "त्यो नामको स्प्राइट पहिले नै अवस्थित छ।",
    err_project_exists: "त्यो नामको परियोजना पहिले नै अवस्थित छ।",
    err_no_content: "बचत गर्न कुनै सामग्री छैन।",
    err_no_changes: "बचत गर्न कुनै परिवर्तन छैन।",
    err_delete_last_sheet: "अन्तिम पाना मेटाउन सकिँदैन।",
    err_extract_frames: "कुनै पनि फ्रेमहरू निकाल्न सकिएन।",
    err_indexeddb: "स्थानीय रूपमा बचत गर्न असफल भयो। तपाईंको ब्राउजरले IndexedDB लाई समर्थन नगर्न सक्छ।",
    msg_upload_success: "अपलोड सफल भयो: {0}",
    msg_upload_failed: "अपलोड असफल: {0}",
    msg_save_success: "सफल बचत गर्नुहोस्।",
    msg_saving: "बचत गर्दै...",
    msg_multi_save_result: "बचत गरिएको {0} सम्पत्ति। {1} विफलताहरू।",
    menu_title: "मेनु",
    menu_save: "बचत गर्नुहोस्",
    menu_save_all: "सबै बचत गर्नुहोस्",
    menu_support: "सहायतालाई सम्पर्क गर्नुहोस्",
    label_local_storage: "स्थानीय भण्डारण",
    label_sign_in: "साइन इन गर्नुहोस्",
    modal_export_title: "स्प्राइट निर्यात गर्नुहोस्",
    label_filename: "फाइलनाम",
    label_format: "ढाँचा",
    action_export_confirm: "निर्यात गर्नुहोस्",
};

export default translations;
